'use client';

import dynamic from 'next/dynamic';
import { useRouter } from 'next/navigation';
import { useAccountUm } from '@/hooks/use-account-um';
import { useGlobalContext } from '@/store/contexts/global-context';
import { useStore } from '@/store/store';
import {
    getZoneCtaClickedProps,
    LIVESTREAM_ENTRY_POINT_LINK_TEXT,
    LIVESTREAM_ENTRY_POINT_MODULE
} from '@/tracking/amplitude/events/general/livestream-entry-point';
import { LIVESTREAM_PAGE_ENTRY_POINT_DEFAULTS } from './constants';
import type { LivestreamPageEntryPointProps } from './types';
import './styles/@theme';

const LiveStreamPreviewCard = dynamic(
    () => import('@fanduel/casino-streaming-um-web').then((module) => module.LiveStreamPreviewCard),
    { ssr: false }
);

export const LivestreamPageInfluencerHubEntryPoint = ({
    categoryPath,
    label,
    previewImageUrl,
    avatarUrl,
    previewTitle = 'Casino Livestream'
}: LivestreamPageEntryPointProps) => {
    const router = useRouter();
    const { isLoggedIn } = useGlobalContext();
    const { triggerLogin } = useAccountUm();
    const { sendEvent } = useStore((state) => state.tracking);

    if (!previewImageUrl || !categoryPath) {
        return null;
    }

    const handleCtaClick = () => {
        const eventProps = getZoneCtaClickedProps({
            module: LIVESTREAM_ENTRY_POINT_MODULE.INFLUENCER_HUB,
            linkText: LIVESTREAM_ENTRY_POINT_LINK_TEXT.THUMBNAIL
        });
        sendEvent([{ destination: 'amplitude', eventProps }]);

        if (!isLoggedIn) {
            triggerLogin({ externalReferrer: categoryPath.replace(/^\/+/, '') });
            return;
        }

        router.push(categoryPath);
    };

    return (
        <div className="livestream-page-entry-point" data-testid="livestream-preview-card-zone">
            <LiveStreamPreviewCard
                label={
                    label
                        ? {
                              text: label,
                              style: { color: 'var(--livestream-zone-title-color)' }
                          }
                        : undefined
                }
                preview={{
                    image: { src: previewImageUrl },
                    avatar: avatarUrl ? { src: avatarUrl } : undefined,
                    title: previewTitle
                }}
                cta={{
                    label: LIVESTREAM_PAGE_ENTRY_POINT_DEFAULTS.CTA_LABEL,
                    onClick: handleCtaClick
                }}
            />
        </div>
    );
};
